import React, { createContext, useContext, useEffect, useState, useCallback } from "react";

const Ctx = createContext(null);

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => {
    try { return localStorage.getItem("a4u_theme") || "dark"; } catch { return "dark"; }
  });

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    document.documentElement.classList.toggle("light", theme === "light");
    try { localStorage.setItem("a4u_theme", theme); } catch (_) {}
  }, [theme]);

  const toggle = useCallback(() => setTheme(t => (t === "dark" ? "light" : "dark")), []);
  return <Ctx.Provider value={{ theme, setTheme, toggle }}>{children}</Ctx.Provider>;
};

export const useTheme = () => useContext(Ctx) || { theme: "dark", toggle: () => {} };
